import { every, partition } from 'lodash-es';

import { ChecklistInvoiceExpenseAmounts } from '../models/quarter-close-checklist.model';

// When calculating the Checklist invoice total,
// we only include invoice totals if they contain
// at least one non-zero categorized value.
export function validateInvoiceExpenses(
  expenseAmounts: ChecklistInvoiceExpenseAmounts,
  isPivoted: boolean
): [boolean, number] {
  // Splitting expense amounts
  const [categorized, total] = partition(expenseAmounts, (expense) => {
    return expense.amount_type !== 'AMOUNT_TOTAL';
  });

  // Invoice total is not valid if all
  // categorized expense amounts are 0.
  const allZeroExpenses = every(categorized, (expense) => {
    return expense.amount === 0;
  });

  const invoiceTotal = total?.[0]?.amount || 0;

  return [isPivoted ? total?.[0]?.amount !== null : !allZeroExpenses, invoiceTotal];
}
